export const SIGNALR_PATH = '/hub/notificationhub';
